<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Centros de Custos</mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                <mat-form-field fxFlex="50%" fxFlexOffset="20px">
                    <mat-label>Contas:</mat-label>
                    <mat-select [(ngModel)]=contasCentrosCusto.contasBancaria.id name="contas" required>
                        <mat-option *ngFor="let m of listaContasBancarias" [value]="m.id">
                            {{m.banco.numero}} - {{m.banco.nome}}: Agência {{m.numeroAgencia}} Conta {{m.numeroContaBancaria}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="listaContasBancarias?.length === 0" align="start">Nenhuma conta cadastrada</mat-hint>
                </mat-form-field>

            </div>

            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
            style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

            <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                Limpar
            </button>

            <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                fxFlex="20%" color="primary" (click)="adicionar()">
                Adicionar
            </button>

            <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                fxFlex="20%" color="primary" (click)="atualizar()">
                Atualizar
            </button>

        </div>

           
        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Lista de Contas Centro de Custo ( {{listaContasCentrosCusto?.length}} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">

                <ng-container matColumnDef="banco">
                    <th mat-header-cell *matHeaderCellDef> Banco </th>
                    <td mat-cell *matCellDef="let element"> {{element?.contasBancaria?.banco?.numero}} - {{element?.contasBancaria?.banco?.nome}}  </td>
                </ng-container>

                <ng-container matColumnDef="agencia">
                    <th mat-header-cell *matHeaderCellDef> Agência </th>
                    <td mat-cell *matCellDef="let element"> {{element?.contasBancaria?.numeroAgencia}} </td>
                </ng-container>

                <ng-container matColumnDef="conta">
                    <th mat-header-cell *matHeaderCellDef> Conta </th>
                    <td mat-cell *matCellDef="let element"> {{element?.contasBancaria?.numeroContaBancaria}} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button  mat-button (click)="atualizarCentrosDeCusto(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row"  fxLayoutAlign="end center" fxLayoutGap="16px"
                style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar nova conta" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion> 
</form>

